import {Theme} from "@core-ui/react-stitch";

export const outline = (theme: Theme) => {
  const outlines = {
    at: {
      default: {
        inner: {size: "", color: ""},
        outer: {size: "", color: ""},
      },
      selected: {
        inner: {size: "0.1875rem", color: theme.color.wh},
        outer: {size: "0.375rem", color: theme.color.bk},
      },
      invert: {
        default: {
          inner: {size: "1px", color: theme.color.inverse.b1},
          outer: {size: "2px", color: theme.color.inverse.g1},
        },
        selected: {
          inner: {size: "1px", color: theme.color.bk},
          outer: {size: "3px", color: theme.color.wh},
        },
      },
      small: {
        default: {
          inner: {size: "", color: ""},
          outer: {size: "", color: ""},
        },
        selected: {
          inner: {size: "1px", color: theme.color.wh},
          outer: {size: "2px", color: theme.color.b1},
        },
      },
    },
    atRedesign: {
      default: {
        inner: {size: "", color: ""},
        outer: {size: "", color: ""},
      },
      selected: {
        inner: {size: "2px", color: theme.color.wh},
        outer: {size: "3px", color: theme.color.bk},
      },
      invert: {
        default: {
          inner: {size: "1px", color: theme.color.inverse.b1},
          outer: {size: "2px", color: theme.color.inverse.g1},
        },
        selected: {
          inner: {size: "1px", color: theme.color.bk},
          outer: {size: "3px", color: theme.color.wh},
        },
      },
      small: {
        default: {
          inner: {size: "", color: ""},
          outer: {size: "", color: ""},
        },
        selected: {
          inner: {size: "1px", color: theme.color.wh},
          outer: {size: "2px", color: theme.color.b1},
        },
      },
    },
    gap: {
      default: {
        inner: {size: "", color: ""},
        outer: {size: "", color: ""},
      },
      selected: {
        inner: {size: "0.1875rem", color: theme.color.wh},
        outer: {size: "0.375rem", color: theme.color.b1},
      },
      invert: {
        default: {
          inner: {size: "1px", color: theme.color.inverse.b1},
          outer: {size: "2px", color: theme.color.inverse.g1},
        },
        selected: {
          inner: {size: "1px", color: theme.color.bk},
          outer: {size: "3px", color: theme.color.wh},
        },
      },
      small: {
        default: {
          inner: {size: "", color: ""},
          outer: {size: "", color: ""},
        },
        selected: {
          inner: {size: "1px", color: theme.color.wh},
          outer: {size: "2px", color: theme.color.b1},
        },
      },
    },
    gapfs: {
      default: {
        inner: {size: "", color: ""},
        outer: {size: "", color: ""},
      },
      selected: {
        inner: {size: "0.1875rem", color: theme.color.wh},
        outer: {size: "0.375rem", color: theme.color.b1},
      },
      invert: {
        default: {
          inner: {size: "1px", color: theme.color.inverse.b1},
          outer: {size: "2px", color: theme.color.inverse.g1},
        },
        selected: {
          inner: {size: "1px", color: theme.color.bk},
          outer: {size: "3px", color: theme.color.wh},
        },
      },
      small: {
        default: {
          inner: {size: "", color: ""},
          outer: {size: "", color: ""},
        },
        selected: {
          inner: {size: "0.1875rem", color: theme.color.wh},
          outer: {size: "0.375rem", color: theme.color.b2},
        },
      },
    },
    gapRedesign: {
      default: {
        inner: {size: "2px", color: theme.color.wh},
        outer: {size: "3px", color: theme.color.gray20},
      },
      selected: {
        inner: {size: "2px", color: theme.color.wh},
        outer: {size: "4px", color: theme.color.bk},
      },
      invert: {
        default: {
          inner: {size: "1px", color: theme.color.inverse.b1},
          outer: {size: "2px", color: theme.color.inverse.g1},
        },
        selected: {
          inner: {size: "1px", color: theme.color.bk},
          outer: {size: "3px", color: theme.color.wh},
        },
      },
      small: {
        default: {
          inner: {size: "2px", color: theme.color.wh},
          outer: {size: "3px", color: theme.color.gray20},
        },
        selected: {
          inner: {size: "2px", color: theme.color.wh},
          outer: {size: "4px", color: theme.color.bk},
        },
      },
    },
    on: {
      default: {
        inner: {size: "", color: ""},
        outer: {size: "", color: ""},
      },
      selected: {
        inner: {size: "0.1875rem", color: theme.color.wh},
        outer: {size: "0.375rem", color: theme.color.b1},
      },
      invert: {
        default: {
          inner: {size: "1px", color: theme.color.inverse.b1},
          outer: {size: "2px", color: theme.color.inverse.g1},
        },
        selected: {
          inner: {size: "1px", color: theme.color.bk},
          outer: {size: "3px", color: theme.color.wh},
        },
      },
      small: {
        default: {
          inner: {size: "", color: ""},
          outer: {size: "", color: ""},
        },
        selected: {
          inner: {size: "2px", color: theme.color.wh},
          outer: {size: "4px", color: theme.color.b1},
        },
      },
    },
    br: {
      default: {
        inner: {size: "", color: ""},
        outer: {size: "", color: ""},
      },
      selected: {
        inner: {size: "0.1875rem", color: theme.color.wh},
        outer: {size: "0.375rem", color: theme.color.bk},
      },
      invert: {
        default: {
          inner: {size: "1px", color: theme.color.inverse.b1},
          outer: {size: "2px", color: theme.color.inverse.g1},
        },
        selected: {
          inner: {size: "1px", color: theme.color.bk},
          outer: {size: "3px", color: theme.color.wh},
        },
      },
      small: {
        default: {
          inner: {size: "", color: ""},
          outer: {size: "", color: ""},
        },
        selected: {
          inner: {size: "2px", color: theme.color.wh},
          outer: {size: "4px", color: theme.color.bk},
        },
      },
    },
    brfs: {
      default: {
        inner: {size: "", color: ""},
        outer: {size: "", color: ""},
      },
      selected: {
        inner: {size: "0.1875rem", color: theme.color.wh},
        outer: {size: "0.375rem", color: theme.color.bk},
      },
      invert: {
        default: {
          inner: {size: "1px", color: theme.color.inverse.b1},
          outer: {size: "2px", color: theme.color.inverse.g1},
        },
        selected: {
          inner: {size: "1px", color: theme.color.bk},
          outer: {size: "3px", color: theme.color.wh},
        },
      },
      small: {
        default: {
          inner: {size: "", color: ""},
          outer: {size: "", color: ""},
        },
        selected: {
          inner: {size: "2px", color: theme.color.wh},
          outer: {size: "4px", color: theme.color.bk},
        },
      },
    },
    // No underline, different default vs selected styles
    // inner used as padding, outer used as border
    brPdpCatRedesign: {
      default: {
        inner: {size: "2px", color: theme.color.wh},
        outer: {size: "1px", color: theme.color.gray40},
      },
      selected: {
        inner: {size: "1px", color: theme.color.wh},
        outer: {size: "2px", color: theme.color.bk},
      },
      // These styles will need to be adjusted
      // if the catBrRedesign needs to support inverse styles
      invert: {
        default: {
          inner: {size: "2px", color: theme.color.b2},
          outer: {size: "1px", color: theme.color.inverse.b1},
        },
        selected: {
          inner: {size: "1px", color: theme.color.b2},
          outer: {size: "2px", color: theme.color.inverse.b1},
        },
      },
      small: {
        default: {
          inner: {size: "2px", color: theme.color.wh},
          outer: {size: "1px", color: theme.color.gray40},
        },
        selected: {
          inner: {size: "1px", color: theme.color.wh},
          outer: {size: "2px", color: theme.color.bk},
        },
      },
    },
    // Has underline, selected outline styles should remain the same
    // inner used as padding, outer used as border
    brPdpRedesign: {
      default: {
        inner: {size: "1px", color: theme.color.wh},
        outer: {size: "1px", color: theme.color.gray40},
      },
      selected: {
        inner: {size: "1px", color: theme.color.wh},
        outer: {size: "1px", color: theme.color.gray40},
      },
      invert: {
        default: {
          inner: {size: "1px", color: theme.color.b2},
          outer: {size: "1px", color: theme.color.inverse.b1},
        },
        selected: {
          inner: {size: "1px", color: theme.color.b2},
          outer: {size: "1px", color: theme.color.inverse.b1},
        },
      },
      small: {
        default: {
          inner: {size: "1px", color: theme.color.wh},
          outer: {size: "1px", color: theme.color.gray40},
        },
        selected: {
          inner: {size: "1px", color: theme.color.wh},
          outer: {size: "1px", color: theme.color.gray40},
        },
      },
    },
  };
  return outlines;
};
